<template>
  <div v-if="company && user && inited" class="main" :style="'--highlight-color: '+ company.highlight +';'">
    <div class="container">
      <dropdown
        v-if="user && user.superadmin"
        :options="companiesArr"
        :selected="company ? company.name : selected"
        @input="changeCompany"
      />
      <div class="row">
        <div class="col col--6">
          <add-event ref="addEventComponent" />
          <event-chart v-on:add-event="addEvent" :year="year" />
        </div>
        <div class="col col--6">
          <Header v-on:yearChanged="yearChanged" />
          <event-list :year="year" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Header from "@/components/Header";
import AddEvent from "@/components/AddEvent";
import EventChart from "@/components/EventChart";
import EventList from "@/components/EventList";
import Dropdown from "@/components/Dropdown";

export default {
  name: "Index",
  components: {
    Header,
    AddEvent,
    EventChart,
    EventList,
    Dropdown
  },
  data() {
    return {
      companiesArr: [],
      companyId: null,
      events: [],
      selected: null,
      highlightColor: "",
      inited: false
    };
  },
  computed: {
    ...mapState(["user", "companies", "company", "year"])
  },
  watch: {
    "$route.path": "refreshRoute"
  },

  async created() {
    if (this.user == null) {
      await this.$store.dispatch("INIT_USER").then(() => {
        this.init();  
      })
    } else {
      await this.$store.dispatch("FETCH_COMPANIES").then(()=> {
        this.init();
      })
    }
    console.log(this.year);
  },
  methods: {
    init () {
      if (this.$route.params && this.$route.params.companyId) {
        this.$store.commit("SET_COMPANY_BY_ID", this.$route.params.companyId);
      } else {
        this.$store.commit("SET_DEFAULT_COMPANY");
      }

      this.companiesArr = Object.keys(this.companies).map(
        slug => this.companies[slug]
      );

      this.inited = true;
    },
    yearChanged (newYear){
      this.selectedYear = newYear;
    },
    refreshRoute() {
      location.reload();
    },
    addEvent(dateString) {
      this.$refs.addEventComponent.showModal(dateString);
    },
    setCompanyFromUserData() {
      console.log("set company from user data");
    },
    changeCompany({ id }) {
      this.$router.push({
        name: "IndexCompany",
        params: { companyId: id }
      });
    }
  }
};
</script>

<style lang="scss">
.main {
  width: 100%;
}
</style>
